<template>
  <div id="card-propiedades" :class="className" class="px-0 my-2 py-0 parent justify-content-center"   > 
    <!-- <div  class="shadow_card rounded-bottom bg-card px-0 card-div altura-card "   >
    
      <carouselCard class="card-comun"></carouselCard>
      <detailCardProperties></detailCardProperties>
       
     
    </div> -->
    <div class="d-flex child">
      
      <carouselCard 
        :cardInfo="product" 
        :propertyUrl="propertyUrl"
        :autoSlide="autoSlide"
        @share-property="handleShare"
        style="border-top-left-radius: 10px !important; border-bottom-left-radius: 10px !important; border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;" 
        class="card-comun p-0"
      ></carouselCard>
      <div style="width: 100%;" class=" center-vertical" >

        <detailCardProperties :cardInfo="product" :detail="detail" class="px-3  parent" style="   width:100%;  border-top-left-radius: 10px !important; border-bottom-left-radius: 10px !important; border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;"></detailCardProperties>
      </div>
    </div>

    <!-- Modal Compartir -->
    <b-modal centered id="modal-compartir" :title="$t('detail.shareModalTitle')" hide-footer class="m-3">
      <div>
        <b-form-group :label="$t('detail.shareLinkLabel')">
          <div class="share-link-row">
            <b-form-input class="share-link-input" :value="shareUrl" readonly size="sm"></b-form-input>
            <button type="button" class="btn btn-light-secondary-opacity btn-sm share-copy-button" @click="copyToClipboard(shareUrl)">
              {{ $t('detail.copyButton') }}
            </button>
          </div>
        </b-form-group>

        <div class="share-actions mt-3">
          <button type="button" :disabled="shareLoading" @click="shareOnWhatsApp" class="btn btn-pill btn-primary-solid btn-sm share-action-button">
            <i class="fa-brands fa-whatsapp mr-1"></i>
            {{ shareLoading ? $t('detail.preparing') : $t('detail.whatsappLabel') }}
          </button>
          <button type="button" :disabled="shareLoading" @click="shareOnFacebook" class="btn btn-pill btn-primary-solid btn-sm ml-2 share-action-button">
            <i class="fa-brands fa-facebook-f mr-1"></i>
            {{ $t('detail.facebookLabel') }}
          </button>
          <a class="btn btn-primary-solid btn-sm btn-pill ml-2" :href="`mailto:?subject=${$t('detail.emailSubject')}&body=${$t('detail.emailBodyPrefix')} ${shareUrl}`">
            <i class="fa-solid fa-envelope mr-1"></i> {{ $t('detail.emailButton') }}
          </a>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button class="btn btn-pill btn-light-secondary" @click="$bvModal.hide('modal-compartir')">{{ $t('detail.closeButton') }}</button>
        </div>
      </div>
    </b-modal>

  
  </div>
</template>

<script>
import carouselCard from "../components/carouseCardPropiedades.vue";
import detailCardProperties from "../components/detailCardProperties.vue";
import {
  buildFacebookPropertyUrl,
  buildPropertyShareVersion,
  buildVersionedShareUrl,
  buildWhatsAppPropertyUrl,
  getShareVersion,
} from "@/utils/propertyUrl";

export default {
  props: ["product", "detail", "autoSlide"],
  components: {carouselCard, detailCardProperties },
  data: () => ({
    className: "product",
    user: null,
    shareUrl: "",
    shareLoading: false,
    propertyUrl: ""
  }),
  mounted() {
    
    this.propertyUrl = window.location.href;
  },
  methods:{
    handleShare(url) {
      this.shareUrl = buildVersionedShareUrl(url, buildPropertyShareVersion(this.product));
      this.$bvModal.show("modal-compartir");
    },
    async prepareSocialPreview() {
      await this.$store.dispatch("post", {
        path: `Configuracion_General/public/prerender/warm/property/${this.product.Id_propiedad}`,
        data: {
          Domain: window.location.hostname,
          share: getShareVersion(this.shareUrl),
        },
      });
    },
    async shareOnWhatsApp() {
      if (this.shareLoading) return;
      this.shareLoading = true;
      const whatsappWindow = window.open("", "_blank");

      try {
        await this.prepareSocialPreview();
      } catch (error) {
        console.warn("No se pudo precalentar el preview social.", error);
      } finally {
        const whatsappUrl = buildWhatsAppPropertyUrl(this.shareUrl);
        if (whatsappWindow) {
          whatsappWindow.location.href = whatsappUrl;
        } else {
          window.location.href = whatsappUrl;
        }
        this.shareLoading = false;
      }
    },
    async shareOnFacebook() {
      if (this.shareLoading) return;
      this.shareLoading = true;
      const facebookWindow = window.open("", "_blank");

      try {
        await this.prepareSocialPreview();
      } catch (error) {
        console.warn("No se pudo precalentar el preview social.", error);
      } finally {
        const facebookUrl = buildFacebookPropertyUrl(this.shareUrl);
        if (facebookWindow) {
          facebookWindow.location.href = facebookUrl;
        } else {
          window.location.href = facebookUrl;
        }
        this.shareLoading = false;
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$swal({
            icon: "success",
            title: this.$t("detail.copiedTitle"),
            text: this.$t("detail.copiedText"),
            timer: 1500,
            showConfirmButton: false,
          });
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: this.$t("detail.copyErrorTitle"),
            text: this.$t("detail.copyErrorText"),
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.share-link-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.share-link-input {
  min-width: 0;
}
.share-copy-button {
  flex: 0 0 auto;
  align-self: center;
  height: calc(1.5em + 0.5rem + 2px) !important;
  margin: 0 !important;
  padding: 0 0.875rem !important;
  line-height: 1.5 !important;
  border-radius: 0.5rem !important;
}
.share-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}
.share-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  white-space: nowrap;
}
@media (max-width: 576px) {
  .share-link-row {
    flex-direction: column;
  }
  .share-copy-button,
  .share-actions .btn {
    width: 100%;
  }
}
///////////////////////////////
.center-vertical {
  display: flex;
  flex-direction: column; /* Cambia la dirección a columna */
  align-items: center; /* Centra los elementos en el eje vertical */
  justify-content: center; /* Centra en el eje principal (ahora vertical) */
}
#card-propiedades{

  }
  #card-propiedades h3 {
    transition: color 0.2s ease;
  }
  #card-propiedades :hover h3{
    color: var(--primary) !important;
  }
  
  .shadow_card {
    background: transparent;
    box-shadow: 0 .2rem .8rem rgba(0, 0, 0, 0.048)!important;
  }

  .rounded-card-right{
    border-top-right-radius: 10px;
  }
  .rounded-card-right-b{
    border-bottom-right-radius: 10px;
  }

.altura-card{
  height: 100% !important;
  width: 100% !important;
  display:inline-block;
}
.altura-card-detalle{
  height: 15rem !important;
  
}
.altura-card-detalle-propiedades{
  height: 12rem !important;
  
}
.altura-card-footer-propiedades{
  height: auto !important;
  
}
.altura-card-boton{
  height: 50px !important;
  margin-top: 35px;
  margin-left: 15px;
}


  .text-card1{
    height: 100px;
  }
  
  .text-card1 {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

/////////////////
$primary: rgba(255, 0, 119, 1);

.text-card{
  height: 70px;
}

.text-card {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}


.bg-image-card {

  // border-top-right-radius: 10px;
  background-color: #cccccc;
  height: 18rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.radius-border{
  border-top-right-radius: 15px !important;
}

.radius-border-left-bottton{
  border-bottom-right-radius: 15px !important;
}
h4 {
  color: $primary;
}

.product-alt {
  background: transparent;
  border: 1px solid $primary;
  border-radius: 20px;
  margin: 1rem;
  padding: 1rem;
  color: #fff;
}
.productimg{
  height:10rem; width:80%; display:block; margin:auto
}

@media screen and (max-width: 600px) {
  .productimg{
    height:10rem; width:50%; display:block; margin:auto
  }
}
</style>
